import React, { useRef, useEffect } from 'react';
import { View, Text, StyleSheet, Animated, Easing, Dimensions } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import LogoSvg from '../LogoSvg';
import GradientButton from './GradientButton';

const SubscriptionSuccessScreen = ({ onContinue }) => {
    const successOpacity = useRef(new Animated.Value(0)).current;
    
    const screenWidth = Dimensions.get('window').width;
    const screenHeight = Dimensions.get('window').height;

    useEffect(() => {
        Animated.timing(successOpacity, {
            toValue: 1,
            duration: 800,
            easing: Easing.out(Easing.cubic),
            useNativeDriver: false,
        }).start();
    }, []);

    const handleContinue = () => {
        if (onContinue) onContinue();
    };

    return (
        <View style={[styles.successOuterContainer, { height: screenHeight }]}>
            <LinearGradient
                colors={['#749A77', '#2B4E2D']}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
                style={styles.successGradientBackground}
            >
                <View style={[styles.successContainer, { width: screenWidth, height: screenHeight }]}>
                    <Animated.View style={[styles.successContent, { opacity: successOpacity }]}>
                        <View style={styles.successHeader}>
                            <View style={styles.successTitleContainer}>
                                <View style={[styles.logoContainer, { transform: [{ rotate: '103deg' }] }]}>
                                    <LogoSvg 
                                        width={32} 
                                        height={32} 
                                        color="rgba(255, 255, 255, 0.80)" 
                                        spin={false}
                                    />
                                </View>
                                <Text style={styles.successTitle}>Success</Text>
                                <View style={[styles.logoContainer, { transform: [{ rotate: '-150deg' }] }]}>
                                    <LogoSvg 
                                        width={32} 
                                        height={32} 
                                        color="rgba(255, 255, 255, 0.80)" 
                                        spin={false}
                                    />
                                </View>
                            </View>
                        </View>
                        
                        <View style={styles.successSubtitleContainer}>
                            <Text style={styles.successSubtitle}>
                                Your Subscription was Activated Successfully!
                            </Text>
                        </View>
                        
                        <View style={styles.successActions}>
                            <GradientButton
                                text="Continue to Dashboard"
                                onPress={handleContinue}
                                style={styles.successButton}
                                textStyle={styles.successButtonText}
                                gradientColors={["#D2D2D2", "#D2D2D2"]}
                            />
                        </View>
                    </Animated.View>
                </View>
            </LinearGradient>
        </View>
    );
};

const styles = StyleSheet.create({
    successOuterContainer: {
        flex: 1,
        overflow: 'hidden',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    successGradientBackground: {
        flex: 1,
        width: '100%',
    },
    successContainer: {
        flex: 1,
        paddingLeft: 48,
        paddingRight: 48,
        backgroundColor: 'rgba(255, 255, 255, 0)',
        overflow: 'hidden',
        borderWidth: 2,
        borderColor: 'black',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 10,
    },
    successContent: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        gap: 10,
    },
    successHeader: {
        alignSelf: 'stretch',
        paddingTop: 16,
        paddingBottom: 16,
        backgroundColor: 'rgba(255, 255, 255, 0)',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 303,
    },
    successTitleContainer: {
        height: 32,
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: 10,
        flexDirection: 'row',
    },
    successTitle: {
        fontSize: 40,
        fontFamily: 'ClimateCrisis',
        fontWeight: '400',
        textTransform: 'uppercase',
        lineHeight: 40,
        color: 'rgba(255, 255, 255, 0.80)',
    },
    successSubtitleContainer: {
        alignSelf: 'stretch',
        paddingTop: 16,
        paddingBottom: 16,
        backgroundColor: 'rgba(255, 255, 255, 0)',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 303,
    },
    successSubtitle: {
        fontSize: 32,
        fontFamily: 'Slate',
        fontWeight: '500',
        textTransform: 'uppercase',
        lineHeight: 32,
        color: 'rgba(255, 255, 255, 0.80)',
        textAlign: 'center',
    },
    successActions: {
        width: 319,
        justifyContent: 'center',
        alignItems: 'center',
        gap: 20,
        flexDirection: 'row',
    },
    successButton: {
        backgroundColor: 'rgba(116, 154, 119, 0.20)',
        borderColor: 'rgba(116, 154, 119, 0.30)',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.10,
        shadowRadius: 4,
        elevation: 4,
    },
    successButtonText: {
        color: '#D2D2D2',
        fontSize: 15,
        fontFamily: 'Slate',
        fontWeight: '500',
        lineHeight: 20,
    },
    logoContainer: {
        width: 32,
        height: 32,
        position: 'relative',
        overflow: 'visible',
        justifyContent: 'center',
        alignItems: 'center',
    },
});

export default SubscriptionSuccessScreen;
